import { Typography } from '@mui/material'
import React, {useEffect} from 'react'

import { GAME_FACT_BASKET_TIMEOUT } from '../constants.js'
import { useGameFact } from '../useGameFact.js'
import { getVisualTimer } from '../../sports/rules.js'
import TextCustom from '../generic/textCustom.js'

const RecapBasketTimeout = ({state, match, onChangeText, onChangeTitle, inHistory}) => {
    const {team, timer, comment, title, period} = state

    const [img] = useGameFact({type : GAME_FACT_BASKET_TIMEOUT})

    const { homeTeam, awayTeam} = match

    let teamSelected = [homeTeam, awayTeam].find(t => t._id === team)

    const actualPeriod = period ??  match.period

    // Gestion du text
    useEffect(() => {
      if(!state.text || state.edited){
          const monText = 'Temps mort pour '+teamSelected.name+' !'
          
          if(!inHistory)
              onChangeText && onChangeText(monText)
      }

      if(!state.title || state.edited){
          const monTitle = 'TEMPS MORT'
          
          if(!inHistory){
              onChangeTitle && onChangeTitle(monTitle)
          }
              
      }
  }, [])
  
    return (
      <div style={{color : inHistory ? 'black' : 'white'}}>
        <img src={img} width={150}/>
        <Typography>Equipe : {teamSelected.name}</Typography>
        {(timer !== 0 || period !== 0) && <Typography>Minute : {getVisualTimer(actualPeriod, timer, match.discipline)}</Typography>}
        
        {state.title && <TextCustom initialText={state.title} onChangeText={onChangeTitle} label={'Titre'}/>}
        {state.text && <TextCustom initialText={state.text} onChangeText={onChangeText} label={'Texte'}/>}
      </div>
    )
  }

export default RecapBasketTimeout